import React, { useCallback, useMemo } from 'react'

import { useRouter } from 'next/navigation'

import { NewsCard } from 'Components/Blocks'
import { Column, Loader, Row } from 'Components/UI'
import { NewsItem } from 'Types/emajinAPI'

import { BLOG_POST } from 'Constants/Paths'

import { usePaginatedFetch } from 'Hooks'

import APIService from 'Services/API'

import { Container, StyledButton } from './styles'

const ITEM_PER_VIEW = 6

function NewsBoardGallery() {
  const router = useRouter()

  const fetchPage = useCallback(async (page: number) => {
    const res = await APIService.getNews({
      limit: ITEM_PER_VIEW,
      offset: page * ITEM_PER_VIEW,
    })
    return res.news ?? []
  }, [])

  const {
    items: news,
    loading,
    error,
    hasMore,
    loadMore,
    loadingMore,
  } = usePaginatedFetch<NewsItem>({
    limit: ITEM_PER_VIEW,
    fetchPage,
  })

  const loaderMarkup = useMemo(
    () => (
      <Row alignCenter fullWidth height={624} justifyCenter>
        <Loader size={32} />
      </Row>
    ),
    [],
  )

  const handleReadMoreClick = useCallback(
    (data: NewsItem) => {
      sessionStorage.setItem('blogPost', JSON.stringify(data))
      router.push(BLOG_POST(data.id))
    },
    [router],
  )

  if (error) return null

  return (
    <Column alignCenter>
      {loading ? (
        loaderMarkup
      ) : (
        <Column>
          <Container
            gridTemplateColumns={[
              '1fr',
              '1fr',
              'repeat(2, 1fr)',
              'repeat(2, 1fr)',
              'repeat(3, 1fr)',
            ]}
          >
            {news.map(item => (
              <NewsCard
                data={item}
                key={item.id}
                onReadMore={() => handleReadMoreClick(item)}
              />
            ))}
          </Container>

          {loadingMore && loaderMarkup}
        </Column>
      )}

      {hasMore && (
        <StyledButton mt={11} onClick={loadMore}>
          Load More
        </StyledButton>
      )}
    </Column>
  )
}

export default NewsBoardGallery
